import { endpoints } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators/map';
import { Auth } from '../../autentication/Auth';
import { Question } from './../../autentication/models/question';
import { Sms } from './../../autentication/models/sms';

@Injectable()
export class ChangeSecurityQuestionsService {

	constructor(private http: HttpClient) { }

	getForRegistrationSecurityQuestions(): Observable<Question[]> {

		return this.http.get(endpoints.accounts.securityQuestions).pipe(map((data: any) => {
			return data.Retorno.map(item => {
				const question = new Question();
				question.code = item.ID;
				question.description = item.Pergunta;

				return question;
			});
		}));

	}

	saveSecurityQuestions(answers) {

		const questions = answers.map(item => {
			const question = {
				DescricaoPergunta: item.description,
				RespostaPergunta: item.answer,
				CodigoPergunta: item.code
			}

			return question;
		});


		const questionData =
		{
			Perguntas: questions
		}

		return this.http.post(endpoints.accounts.securityQuestions, questionData);


	}
	getSmsCode() {

		return this.http.get(endpoints.accounts.users + Auth.getInstance().getUser().cpf + endpoints.accounts.sms).pipe(map((data: any) => {

			const sms = new Sms();
			sms.uniqueNumer = data.Retorno.NroUnicoMsg;
			sms.type = data.Retorno.TpCodValidacao;
			sms.size = data.Retorno.TamCodValidacao;
			sms.lastDigits = data.Retorno.UltimosDigitosCelular;
			sms.message = data.Mensagem;

			return sms;

		}));


	}

	sendSmsCode(cpf, code) {

		const smsData = {
			Documento: cpf,
			CodigoValidacao: code
		};

		return this.http.post(endpoints.accounts.enviarSms, smsData);

	}

}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-security-questions/change-security-questions.service.ts